module.exports = __webpack_public_path__ + "img/static__image.a06a3d8d.png";